module.exports = __webpack_public_path__ + "img/dis-yiquxiao.908d6976.svg";